<template>
  <div class="with-scrolling-card">
    <div class="with-scrolling-card__tab-wrap">
      <slot></slot>
    </div>
    <div v-if="productInfo && productInfo.productId" class="with-scrolling-card__card-wrap">
      <ProductCardProductPage
        class="with-scrolling-card__card"
        :analytics-data="analyticsData"
        :id="productInfo.productId"
        :code="productInfo.code"
        :title="productInfo.title"
        :title-ru="productInfo.titleRu"
        :title-analytics="productInfo.titleRu"
        :image-url="productInfo.photos && productInfo.photos[0] && productInfo.photos[0].origin_photo"
        :second-image-url="productInfo.photos && productInfo.photos[1] && productInfo.photos[1].origin_photo"
        :rating="productInfo.rate"
        :reviews-count="Number(commentsCount || 0)"
        :price="JSON.stringify({ 'price_new': +productInfo.price, 'price_old': +productInfo.oldPrice })"
        :is-available="productInfo.inStock"
        :is-novelty="productInfo.isNovelty"
        :is-in-wait-list="productInfo.isInWaitList"
        :is-in-wish-list="productInfo.inWishListStatus"
        :badges="JSON.stringify(productInfo.badges)"
        :characteristics="productInfo.shortCharacteristics ? productInfo.shortCharacteristics : []"
        :available-in-store="productInfo.availableInStore"
        :in-stock="productInfo.inStock"
        :is-preorder="isPreorder"
        :is-archive="productInfo.isArchive"
        product-page
        small-card
        opened
        short
      />
    </div>
    <!--    <PriceWithButton-->
    <!--      v-if="(inStock || productInfo.availableInStore) && isAdaptiveMode"-->
    <!--      product-tabs-->
    <!--      with-scrolling-card-->
    <!--      class="with-scrolling-card__price-with-button"-->
    <!--    />-->
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import PriceWithButton from '@/components/product/product-page/PriceWithButton'
import { isAdaptiveMode } from '@/mixins'
import ProductCardProductPage from '@/components/product/product-card/ProductCardProductPage'

export default {
  name: 'WithScrollingCard',
  components: {
    ProductCardProductPage
    // PriceWithButton
  },
  props: {
    analyticsData: {
      type: Array
    }
  },
  mixins: [isAdaptiveMode],
  computed: {
    ...mapState({
      productInfo: state => state.productInfo.productInfo,
      inStock: state => state.productInfo.productInfo.inStock,
      commentsCount: state => state.comments.comments.total_count,
      isPreorder: state => state.productInfo.productInfo.isPreorder
    })
  }
}
</script>

<style scoped lang="sass">

.with-scrolling-card
  display: flex
  flex-flow: row nowrap
  justify-content: space-between

.with-scrolling-card__tab-wrap
  width: 100%

  +mmin($tablet--hor)
    width: 65%

.with-scrolling-card__card-wrap
  display: none

  +mmin($tablet--hor)
    display: block
    width: calc(35% - 50px)

  +mmin(1367)
    width: calc(35% - 70px)

.with-scrolling-card__card
  position: sticky
  top: 82px

.with-scrolling-card__price-with-button

  +mmin($tablet--hor)
    display: none
</style>
